/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class WorkflowService extends HttpHandlerService {
        private logType = "WorkflowService";

        private alwaysShowGotoArrows: boolean;
        public newWorkflowVersionCreated: boolean;

        constructor(
            $http: ng.IHttpService,
            private $q: ng.IQService,
            private $rootScope: ng.IRootScopeService,
            private $window: ng.IWindowService,
            private $location: ng.ILocationService,
            private documentService: services.DocumentService,
            private modalService: any) {
            super($http);
            //this.newWorkflowVersionCreated = false;
        }

        public getStatuses(processConfigId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.StatusGroupsDto> {
            var params: any = {};
            this.handlerUrl = "api/ProcessConfiguration/" + processConfigId + "/Statuses";
            return this.useGetHandler(params);
        }

        public getAllStatusGroups(processConfigId: string): ng.IPromise<models.StatusGroupResult> {
            var params: any = {};
            this.handlerUrl = "api/ProcessConfiguration/" + processConfigId + "/Statuses";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.Workflow.StatusGroupsDto) => {
                    var processStatusGroupResult = new models.StatusGroupResult();
                    processStatusGroupResult.processStatusGroups = this.bindGroupList(result.statusGroups);
                    processStatusGroupResult.isReadonly = result.isReadonly;
                    return processStatusGroupResult;
                });
        }

        public getAllStatusGroupsWithAdditionalInfo(processConfigId: string): ng.IPromise<models.StatusGroupResult> {
            var params: any = {};
            this.handlerUrl = "api/ProcessConfiguration/" + processConfigId + "/Statuses/AllData";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.Workflow.StatusGroupsDto) => {
                    var processStatusGroupResult = new models.StatusGroupResult();
                    processStatusGroupResult.processStatusGroups = this.bindGroupList(result.statusGroups);
                    processStatusGroupResult.isReadonly = result.isReadonly;
                    return processStatusGroupResult;
                });
        }

        public addNewStatus(newStatus: Wars.Domain.Model.Dtos.Workflow.StatusDto, processConfigId: string): ng.IPromise<models.ProcessStatusGroup> {
            this.handlerUrl = "api/ProcessConfiguration/" + processConfigId + "/Status";
            return this.usePostHandler(newStatus).then(
                (result: Wars.Domain.Model.Dtos.Workflow.StatusDto) => {
                    return this.bindGroupItem(result);
                });
        }

        public updateStatus(statusCodeId: string, status: Wars.Domain.Model.Dtos.Workflow.StatusDto): ng.IPromise<models.ProcessStatusGroup> {

            this.handlerUrl = "api/Workflow/Status/" + statusCodeId + "/Update";
            return this.usePostHandler(status).then(
                (result: Wars.Domain.Model.Dtos.Workflow.StatusDto) => {
                    return this.bindGroupItem(result);
                });
        }

        public getStatusChangeDto(statusChangeId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.StatusChangeDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/StatusChange/" + statusChangeId;
            return this.useGetHandler(params);
        }

        public getUserActionDto(userActionId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.UserActionDto> {
            var deferred = this.$q.defer();

            var params: any = {};
            this.handlerUrl = "api/Workflow/UserAction/" + userActionId;
            this.useGetHandler(params).then(
                (userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto) => {
                if (userActionDto.documentConfigurationId) {
                    this.documentService.getDocumentConfiguration(userActionDto.documentConfigurationId).then(
                    (docConfig) => {
                        userActionDto.documentConfiguration = docConfig;
                        deferred.resolve(userActionDto);
                    });
                } else {
                    deferred.resolve(userActionDto);
                }
            });

            return deferred.promise;
        }

        public getMessageDto(messageId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.MessageDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/Message/" + messageId;
            return this.useGetHandler(params);
        }

        public getCreatePdfDto(createPdfId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.CreatePdfDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/CreatePdf/" + createPdfId;
            return this.useGetHandler(params);
        }

        public getCopyDto(copyId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.CopyDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/Copy/" + copyId;
            return this.useGetHandler(params);
        }

        public getSetDataDto(setDataId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.SetDataDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/SetData/" + setDataId;
            return this.useGetHandler(params);
        }

        public getAssignClaimDto(assignClaimId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.AssignClaimDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/AssignClaim/" + assignClaimId;
            return this.useGetHandler(params);
        }

        public getSendEmailDto(sendEmailId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.SendEmailDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/SendEmail/" + sendEmailId;
            return this.useGetHandler(params);
        }

        public getStateDto(stateId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.StateDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/State/" + stateId;
            return this.useGetHandler(params);
        }

        public getConditionDto(conditionId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ConditionDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/Condition/" + conditionId;
            return this.useGetHandler(params);
        }

        public getValidateDto(validateId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ValidateDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/Validate/" + validateId;
            return this.useGetHandler(params);
        }

        public getCalculateDto(calculateId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.CalculateDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/Calculate/" + calculateId;
            return this.useGetHandler(params);
        }

        public getBookResourceDto(bookResourceId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ScheduledResourceDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/BookResource/" + bookResourceId;
            return this.useGetHandler(params);
        }

        public getRemoveResourceDto(removeResourceId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ScheduledResourceDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/RemoveResource/" + removeResourceId;
            return this.useGetHandler(params);
        }

        public getReturnFromProcessActionDto(returnFromProcessActionId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ReturnFromProcessActionDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/ReturnFromProcessAction/" + returnFromProcessActionId;
            return this.useGetHandler(params);
        }

        public getProcessActionDto(processActionId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ProcessActionDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/ProcessAction/" + processActionId;
            return this.useGetHandler(params);
        }

        public getSystemActionDto(systemActionId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.SystemActionDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/SystemAction/" + systemActionId;
            return this.useGetHandler(params);
        }

        public getChangeStateDto(changeStateId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.ChangeStateDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/ChangeState/" + changeStateId;
            return this.useGetHandler(params);
        }

        public getGotoStateDto(gotoStateId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.GotoStateDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/GotoState/" + gotoStateId;
            return this.useGetHandler(params);
        }

        public getOutputOrder(workflowBlockId: string): ng.IPromise<Wars.Domain.Model.Dtos.Workflow.WorkflowBlockOutputOrderDto> {
            var params: any = {};
            this.handlerUrl = "api/Workflow/OutputOrder/" + workflowBlockId;
            return this.useGetHandler(params);
        }

        public updateOutputOrder(dto: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockOutputOrderDto) : ng.IPromise<string> {
            var params = dto;
            this.handlerUrl = "api/Workflow/UpdateOutputOrder";
            return this.usePostHandler(params);
        }

        public createNewWorkflowBlock(
            blockType: number,
            statusCodeId: string,
            processActionId: string,
            connectionsDto: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddContextDto): ng.IPromise<models.IWorkflowBlock>
        {
            var params = {
                statusCodeId: statusCodeId,
                processActionId: processActionId,
                blockType: blockType,
                name: models.WorkflowBlockManager.getWorkflowBlockNameByType(blockType),
                addContext: connectionsDto
            };

            this.handlerUrl = "api/Workflow/WorkflowBlock";
            return this.usePostHandler(params).then((workflowBlock) => this.bindBlockItem(workflowBlock));
        }

        public createNewWorkflowBlockInBetween(addContext: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddInBetweenContextDto): ng.IPromise<models.IWorkflowBlock> {
           this.handlerUrl = "api/Workflow/WorkflowBlock/InBetween";
           return this.usePostHandler(addContext).then((workflowBlock) => this.bindBlockItem(workflowBlock));
        }

        public updateStatusChange(workflowBlock: models.StatusChangeWorkflowBlock) {
            var params = workflowBlock.statusChangeDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/StatusChange/" + workflowBlock.statusChangeId;
            return this.usePostHandler(params);
        }

        public updateUserAction(workflowBlock: models.UserActionWorkflowBlock) : ng.IPromise<string> {
            if (!this.documentService.hasChanges()) {
                return this.updateUserActionInternal(workflowBlock);
            }

            var deferred = this.$q.defer();

            this.documentService.saveAllChanges(() => {
                this.updateUserActionInternal(workflowBlock).then(
                (name: string) => {
                    deferred.resolve(name);
                    },
                (failureReason) => {
                    deferred.reject(failureReason);
                });
            });

            return deferred.promise;
        }

        private updateUserActionInternal(workflowBlock: models.UserActionWorkflowBlock): ng.IPromise<string> {
            var params = angular.copy(workflowBlock.userActionDto);
            if (!params.commentAllowed) params.commentRequired = false;
            if (!params.attachmentAllowed) params.attachmentRequired = false;
            params.documentConfiguration = null;
            this.handlerUrl = "api/Workflow/WorkflowBlock/UserAction/" + workflowBlock.id;
            return this.usePostHandler(params);
}

        public updateMessage(workflowBlock: models.MessageWorkflowBlock) {
            var params = workflowBlock.messageDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/Message/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateCreatePdf(workflowBlock: models.CreatePdfWorkflowBlock) {
            var params = workflowBlock.createPdfDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/CreatePdf/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateCopy(workflowBlock: models.CopyWorkflowBlock) {
            var params = workflowBlock.copyDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/Copy/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateSetData(workflowBlock: models.SetDataWorkflowBlock) {
            var params = workflowBlock.setDataDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/SetData/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateAssignClaim(workflowBlock: models.AssignClaimWorkflowBlock) {
            var params = workflowBlock.assignClaimDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/AssignClaim/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateSendEmail(workflowBlock: models.SendEmailWorkflowBlock) {
            var params = workflowBlock.sendEmailDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/SendEmail/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateState(workflowBlock: models.StateWorkflowBlock) {
            var params = workflowBlock.stateDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/State/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateCondition(workflowBlock: models.ConditionWorkflowBlock) {
            var params = workflowBlock.conditionDto;
            this.handlerUrl = "api/Workflow/WorkflowBlock/Condition/" + workflowBlock.id;
            return this.usePostHandler(params);
        }

        public updateValidate(workflowBlock: models.ValidateWorkflowBlock) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/Validate/" + workflowBlock.id;
            return this.usePostHandler(workflowBlock.validateDto);
        }

        public updateCalculate(workflowBlock: models.CalculateWorkflowBlock) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/Calculate/" + workflowBlock.id;
            return this.usePostHandler(workflowBlock.calculateDto);
        }

        public updateScheduledResource(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.ScheduledResourceDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/UpdateScheduledResource/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public updateReturnFromProcessAction(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.ReturnFromProcessActionDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/ReturnFromProcessAction/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public updateProcessAction(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.ProcessActionDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/ProcessAction/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public updateSystemAction(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.SystemActionDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/SystemAction/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public updateChangeState(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.ChangeStateDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/ChangeState/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public updateGotoState(workflowBlockId: string, dto: Wars.Domain.Model.Dtos.Workflow.GotoStateDto) {
            this.handlerUrl = "api/Workflow/WorkflowBlock/GotoState/" + workflowBlockId;
            return this.usePostHandler(dto);
        }

        public deleteWorkflowBlock(id: string, fromBlockId: string, isGotoBlock: boolean, gotoBlockToBlockId?: number): ng.IPromise<models.IWorkflowBlock> {
            var params = {
                fromBlockId: fromBlockId,
                gotoBlockToBlockId: gotoBlockToBlockId
            };
            this.handlerUrl = isGotoBlock ? "api/Workflow/WorkflowBlock/Delete/Goto/" : "api/Workflow/WorkflowBlock/Delete/" + id;
            return this.usePostHandler(params);
        }

        public updateGotoBlock(
            fromBlock: models.IWorkflowBlock,
            toBlock: models.IWorkflowBlock,
            isTo: boolean,
            isYes: boolean,
            isNo: boolean,
            multiOutputIndex: number): ng.IPromise<boolean> {
            var params = {
                toBlockId: toBlock ? toBlock.id : undefined,
                isTo: isTo,
                isYes: isYes,
                isNo: isNo,
                multiOutputIndex: multiOutputIndex
        };
            this.handlerUrl = "api/Workflow/WorkflowBlock/Update/" + fromBlock.id;
            return this.usePostHandler(params);
        }

        public getProcessData(processConfigId: string) {
            var params: any = {};
            this.handlerUrl = "api/Workflow/" + processConfigId + "/Variables";
            return this.useGetHandler(params);
        }

        public validateStatusGroup(statusCodeId: string) {
            var params: any = {};
            this.handlerUrl = "api/Workflow/StatusGroup/" + statusCodeId + "/ValidationIssues";
            return this.useGetHandler(params);
        }

        public getAlwaysShowGotoArrowsSetting(): boolean {
            try {
                if (this.alwaysShowGotoArrows !== undefined) return this.alwaysShowGotoArrows;
                this.alwaysShowGotoArrows = localStorage.getItem("WARS_AlwaysShowGotoArrows") === "yes";
                return this.alwaysShowGotoArrows;
            } catch (exception) {
                services.WarsLogger.logError(exception, this.logType);
                this.alwaysShowGotoArrows = false;
                return false;
            }
        }

        public setAlwaysShowGotoArrowsSetting(showGotoArrows: boolean): void {
            try {
                this.alwaysShowGotoArrows = showGotoArrows;
                localStorage.setItem("WARS_AlwaysShowGotoArrows", showGotoArrows ? "yes" : "no");
            } catch (exception) {
                services.WarsLogger.logError(exception, this.logType);
            }
        }

        public addOrRemoveFeedbackArrowLines(): void {
            var lineElements = Snap.selectAll(".toggle-enabled-feedback-arrow");

            if (this.alwaysShowGotoArrows) {
                for (let i = 0; i < lineElements.length; i++) {
                    const element: Snap.Element = lineElements[i];
                    element.animate({ opacity: '1' }, 300);
                }
            } else {
                for (let i = 0; i < lineElements.length; i++) {
                    const element: Snap.Element = lineElements[i];
                    element.attr({ opacity: '0' });
                }
            }

            var arrowElements = Snap.selectAll(".toggle-enabled-feedback-arrow-tip");

            if (this.alwaysShowGotoArrows) {
                for (let i = 0; i < arrowElements.length; i++) {
                    const element: Snap.Element = arrowElements[i];
                    element.animate({ opacity: '1' }, 300);
                }
            } else {
                for (let i = 0; i < arrowElements.length; i++) {
                    const element: Snap.Element = arrowElements[i];
                    element.attr({ opacity: '0' });
                }
            }
        }

        public showOutputOrderModal(workflowBlock: models.IWorkflowBlock, isReadonly: boolean) {
            var model: models.OutputOrderModel = {
                workflowBlock: workflowBlock,
                isReadonly: false, // TODO: fix this later
                dto: undefined
            };

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_outputOrderSettingsModal.html",
                controller: "outputOrderSettingsModalController",
                inputs: {
                    model: model
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        this.updateOutputOrder(model.dto).then(
                            (orderedDestinationIds) => {
                                var currentToBlocks = model.workflowBlock.toBlocks;
                                var gotos = Enumerable.from(currentToBlocks).where(i => i.type === Wars.Domain.Model.Codes.Enums.BlockType.Goto).toArray();
                                
                                model.workflowBlock.toBlocks = [];
                                model.workflowBlock.toBlockIds = [];

                                for (var i = 0; i < currentToBlocks.length; i++) {
                                    if (currentToBlocks[i].type === Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                                        model.workflowBlock.toBlockIds.push(currentToBlocks[i].id);
                                        model.workflowBlock.toBlocks.push(currentToBlocks[i]);
                                    } else {
                                        var firstOrDefault = Enumerable.from(currentToBlocks).firstOrDefault(x => x.id === orderedDestinationIds[i]);
                                        if (firstOrDefault) {
                                            model.workflowBlock.toBlockIds.push(orderedDestinationIds[i]);
                                            model.workflowBlock.toBlocks.push(firstOrDefault);
                                        } else {
                                            var gotoMatch = Enumerable.from(gotos).first(x => x.toBlocks[0].id === orderedDestinationIds[i]);
                                            model.workflowBlock.toBlockIds.push(gotoMatch[i]);
                                            model.workflowBlock.toBlocks.push(gotoMatch);
                                        }
                                    }
                                }

                                this.$rootScope.$broadcast('re-draw-workflow');
                            });
                    } 
                });
            });
        }

        private bindGroupItem(item: Wars.Domain.Model.Dtos.Workflow.StatusDto): models.ProcessStatusGroup {
            var blocks = this.bindBlockList(item.workflowBlocks);
            var processStatusGroup = new models.ProcessStatusGroup();
            processStatusGroup.intitialize(item, blocks);
            return processStatusGroup;
        }

        private bindGroupList(list: any): models.ProcessStatusGroup [] {
            var processStatusGroups: models.ProcessStatusGroup[] = [];
            if (!list) return processStatusGroups;

            for (var i = 0; i < list.length; i++) {
                processStatusGroups.push(this.bindGroupItem(list[i]));
            }

            return processStatusGroups;
        }

        private bindBlockItem(item: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockDto) : models.IWorkflowBlock {
            switch (item.blockType) {

                case Wars.Domain.Model.Codes.Enums.BlockType.Condition:
                    var conditionBlock = new models.ConditionWorkflowBlock(item.id, item.name);
                    conditionBlock.setQuickLinkInfo(item.componentId, this);
                    this.setCommonProperties(conditionBlock, item);
                    if (item.myConditionDto) conditionBlock.populateDto(item.myConditionDto);
                    return conditionBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.Message:
                    var messageBlock = new models.MessageWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(messageBlock, item);
                    if (item.myMessageDto) messageBlock.populateDto(item.myMessageDto);
                    return messageBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.State:
                    var stateBlock = new models.StateWorkflowBlock(item.id, item.name, item.isInitialWorkflowBlock);
                    this.setCommonProperties(stateBlock, item);
                    if (item.myStateDto) stateBlock.populateDto(item.myStateDto);
                    return stateBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.StatusChange:
                    var statusChangeBlock = new models.StatusChangeWorkflowBlock(item.id, item.name);
                    statusChangeBlock.statusChangeId = item.statusChangeId;
                    statusChangeBlock.toStatusGroupId = item.toStatusGroupId;
                    this.setCommonProperties(statusChangeBlock, item);
                    return statusChangeBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.CustomAction:
                    var systemActionBlock = new models.CustomActionWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(systemActionBlock, item);
                    return systemActionBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.UserAction:
                    var userActionBlock = new models.UserActionWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(userActionBlock, item);
                    if (item.myUserActionDto) userActionBlock.populateDto(item.myUserActionDto);
                    return userActionBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.Copy:
                    var copyBlock = new models.CopyWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(copyBlock, item);
                    if (item.myCopyDto) copyBlock.populateDto(item.myCopyDto);
                    return copyBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.SetData:
                    var setDataBlock = new models.SetDataWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(setDataBlock, item);
                    if (item.mySetDataDto) setDataBlock.populateDto(item.mySetDataDto);
                    return setDataBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.AssignClaim:
                    var assignClaimBlock = new models.AssignClaimWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(assignClaimBlock, item);
                    if (item.myAssignClaimDto) assignClaimBlock.populateDto(item.myAssignClaimDto);
                    return assignClaimBlock;

                case Wars.Domain.Model.Codes.Enums.BlockType.Validate:
                    var validate = new models.ValidateWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(validate, item);
                    if (item.myValidateDto) validate.populateDto(item.myValidateDto);
                    return validate;

                case Wars.Domain.Model.Codes.Enums.BlockType.CreatePdfAction:
                    var createPdf = new models.CreatePdfWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(createPdf, item);
                    if (item.myCreatePdfDto) createPdf.populateDto(item.myCreatePdfDto);
                    return createPdf;

                case Wars.Domain.Model.Codes.Enums.BlockType.SendEmailAction:
                    var sendEmail = new models.SendEmailWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(sendEmail, item);
                    if (item.mySendEmailDto) sendEmail.populateDto(item.mySendEmailDto);
                    return sendEmail;

                case Wars.Domain.Model.Codes.Enums.BlockType.CalculateAction:
                    var calculate = new models.CalculateWorkflowBlock(item.id, item.name);
                    calculate.setQuickLinkInfo(item.componentId, this);
                    this.setCommonProperties(calculate, item);
                    if (item.myCalculateDto) calculate.populateDto(item.myCalculateDto);
                    return calculate;

                case Wars.Domain.Model.Codes.Enums.BlockType.BookResource:
                    var bookResource = new models.BookResourceWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(bookResource, item);
                    if (item.myScheduledResourceDto) bookResource.populateDto(item.myScheduledResourceDto);
                    return bookResource;

                case Wars.Domain.Model.Codes.Enums.BlockType.RemoveResource:
                    var removeResource = new models.RemoveResourceWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(removeResource, item);
                    if (item.myScheduledResourceDto) removeResource.populateDto(item.myScheduledResourceDto);
                    return removeResource;

                case Wars.Domain.Model.Codes.Enums.BlockType.StartProcessAction:
                    var startProcessAction = new models.StartProcessActionWorkflowBlock(item.id, item.name, item.isInitialWorkflowBlock);
                    this.setCommonProperties(startProcessAction, item);
                    if (item.myStartProcessActionDto) startProcessAction.populateDto(item.myStartProcessActionDto);
                    return startProcessAction;

                case Wars.Domain.Model.Codes.Enums.BlockType.ReturnFromProcessAction:
                    var returnFromProcessAction = new models.ReturnFromProcessActionWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(returnFromProcessAction, item);
                    if (item.myReturnFromProcessActionDto) returnFromProcessAction.populateDto(item.myReturnFromProcessActionDto);
                    return returnFromProcessAction;

                case Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction:
                    var processAction = new models.ProcessActionWorkflowBlock(item.id, item.name);
                    processAction.setQuickLinkInfo(item.componentId, this);
                    this.setCommonProperties(processAction, item);
                    if (item.myProcessActionDto) processAction.populateDto(item.myProcessActionDto);
                    return processAction;

                case Wars.Domain.Model.Codes.Enums.BlockType.SystemAction:
                    var systemAction = new models.SystemActionWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(systemAction, item);
                    if (item.mySystemActionDto) systemAction.populateDto(item.mySystemActionDto);
                    return systemAction;

                case Wars.Domain.Model.Codes.Enums.BlockType.ChangeState:
                    var changeState = new models.ChangeStateWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(changeState, item);
                    if (item.myChangeStateDto) changeState.populateDto(item.myChangeStateDto);
                    return changeState;

                case Wars.Domain.Model.Codes.Enums.BlockType.GotoState:
                    var gotoState = new models.GotoStateWorkflowBlock(item.id, item.name);
                    this.setCommonProperties(gotoState, item);
                    if (item.myGotoStateDto) gotoState.populateDto(item.myGotoStateDto);
                    return gotoState;

                default:
                    throw "Invalid workflow block type: " + item.blockType;
            }
        }

        public quickLink(workflowBlock: models.IWorkflowBlock): void {
            if (!workflowBlock.componentId) return;
            var url = undefined;
            switch (workflowBlock.type) {
                case Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction:
                    url = this.getQuickLinkUrl("ProcessActions", workflowBlock.componentId);
                    break;
                case Wars.Domain.Model.Codes.Enums.BlockType.CalculateAction:
                    url = this.getQuickLinkUrl("Calculations", workflowBlock.componentId);
                    break;
                case Wars.Domain.Model.Codes.Enums.BlockType.Condition:
                    url = this.getQuickLinkUrl("Conditions", workflowBlock.componentId);
                    break;
            }
            if (!url) return;
            this.$rootScope.$apply(() => this.$window.open(url, "_blank"));
        }

        private getQuickLinkUrl(componentUrlPart: string, componentId: string) {
            const currentLocation = this.$location.absUrl();
            const marker = "/Manage/";
            const indexOf = currentLocation.indexOf(marker);
            const url = currentLocation.substr(0, indexOf + marker.length - 1) + "/" + componentUrlPart + "/" + componentId;
            return url;
        }

        private setCommonProperties(workflowBlock: models.IWorkflowBlock, item: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockDto) : void {
            workflowBlock.processActionId = item.processActionId;
            workflowBlock.statusCodeId = item.statusCodeId;
            workflowBlock.description = item.description;
        }

        public bindBlockList(list: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockDto[]) : models.IWorkflowBlock[] {
            var workflowBlocks: models.IWorkflowBlock[] = [];
            if (!list) return workflowBlocks;

            for (var i = 0; i < list.length; i++) {
                var workflowBlock = this.bindBlockItem(list[i]);
                workflowBlock.toBlockIds = list[i].toBlockIds;
                workflowBlocks.push(workflowBlock);
            }

            this.tieUpRelationShips(workflowBlocks);

            return workflowBlocks;
        }

        private tieUpRelationShips(workflowBlocks: models.IWorkflowBlock[]) : void {
            for (var i = 0; i < workflowBlocks.length; i++) {
                var currentBlock = workflowBlocks[i];
                var outputType = currentBlock.getOutputType();
                switch (outputType) {
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.Single:
                        var singleOutputBlock = <models.SingleOutputWorkflowBlock>currentBlock;
                        if (singleOutputBlock.toBlockIds && singleOutputBlock.toBlockIds.length > 0)
                            singleOutputBlock.toBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id === singleOutputBlock.toBlockIds[0]);
                        break;
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.Multiple:
                        var multipleOutputBlock = <models.MultipleOutputWorkflowBlock>currentBlock;
                        for (var index = 0; index < multipleOutputBlock.toBlockIds.length; index++) {
                            var currentToId = multipleOutputBlock.toBlockIds[index];
                            var match = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id === currentToId);
                            if (match) multipleOutputBlock.toBlocks.push(match);
                        }
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo:
                        var yesNoBlock = <models.YesNoOutputWorkflowBlock>currentBlock;
                        if (yesNoBlock.toBlockIds && yesNoBlock.toBlockIds.length > 0)
                            yesNoBlock.yesBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id === yesNoBlock.toBlockIds[0]);
                        if (yesNoBlock.toBlockIds && yesNoBlock.toBlockIds.length > 1)
                            yesNoBlock.noBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id === yesNoBlock.toBlockIds[1]);
                        break;
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.None:
                        break;
                    
                    default:
                }
            }
        }

        public createNewDataOperation(dto: Wars.Domain.Model.Dtos.Workflow.SetDataDto): Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto {
            if (!dto.mySetDataOperations) {
                dto.mySetDataOperations = [];
            }

            var newSetDataOperation = this.createNewSetDataOperationInternal(dto.mySetDataOperations.length);

            dto.mySetDataOperations.push(newSetDataOperation);

            return newSetDataOperation;
        }

        public createNewListDataOperation(dto: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto): Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto {
            if (!dto.mySetListDataOperations) {
                dto.mySetListDataOperations = [];
            }

            var newSetDataOperation = this.createNewSetDataOperationInternal(dto.mySetListDataOperations.length);

            dto.mySetListDataOperations.push(newSetDataOperation);

            return newSetDataOperation;
        }

        private createNewSetDataOperationInternal(executionOrder: number): Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto {
            var newSetDataOperation = {
                id: UtilityService.generateGuidComb(),
                executionOrder: executionOrder,
                operationDataType: undefined,
                clearDataType: undefined,
                formId: undefined,
                listObjectSchema_id: undefined,
                fielSchemaProperty_id: undefined,
                setDataType: undefined,
                sourceTreeItem_id: undefined,
                destinationTreeItem_id: undefined,
                mySetListDataOperations: [],
                parentSetDataOperation_id: undefined
            };
            return newSetDataOperation;
        }
    }
}

warsApp.registerService('WorkflowService', ['$http', "$q", "$rootScope", "$window", "$location", "documentService", "ModalService"]);